import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { confirmAlert } from 'react-confirm-alert';

/* MODAL */
import { useModal } from 'hooks/modalContext';
import CloseBtn from 'components/util/CloseModal';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

/* DatePicker */
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

const GoToWorkModal = props => {
  const { closeModal } = useModal();

  const [item, setItem] = useState({
    fkWorkerId: '',
    fkCustMstSeq: '',
    attendanceState: '',
    workerName: '',
    lat: '',
    lon: '',
    inTimeValue: '',
    inTime: '',
    workDate: '',
    lateReason: '',
    lateCheckYn: 'Y',
  });
  const [isSubmit, setIsSubmit] = useState(false);

  useEffect(() => {
    if (moment().format('YYYY-MM-DD') === props.props?.data.item.workDate) {
      setItem(props.props?.data.item);
    } else {
      setItem({ ...props.props?.data.item, ...{ attendanceState: 'A' } });
    }
  }, [props]);

  const validation = () => {
    if (Common.isEmpty(item.attendanceState)) {
      Common.errorMsg('Select Status.');

      return false;
    }

    switch (item.attendanceState) {
      case 'A':
        if (Common.isEmpty(item.lateReason)) {
          Common.errorMsg('Reason required.');

          return false;
        }

        break;
      default:
        if (Common.isEmpty(item.inTime)) {
          Common.errorMsg('Select Go to work time.');

          return false;
        }

        break;
    }

    return true;
  };

  const setAttendance = () => {
    if (validation() && !isSubmit) {
      confirmAlert({
        title: 'Are you sure you want to check?',
        buttons: [{
          label: 'Yes',
          onClick: () => {
            setIsSubmit(true);

            Server.sendPost('workforce/commute', item, setAttendanceCallback).then();
          }
        }, {
          label: 'No'
        }]
      });
    }
  };

  const setAttendanceCallback = () => {
    setIsSubmit(false);

    props.props.data.callback();

    Common.alertSuccess();

    closeModal();
  };

  return (
    <>
      <CloseBtn onClick={closeModal}/>
      <div className='modal-box'>
        <div className='inner'>
          <Title>
            <TitHead>
              <i/>
              <h4>Go to work Registration</h4>
            </TitHead>
          </Title>
          <ModalForm>
            <FormIn>
              <FormInWrap>
                <label>Date</label>
                <FormInput
                  type='text'
                  id='workDate'
                  name='workDate'
                  readOnly={true}
                  value={item?.workDate || ''}
                />
              </FormInWrap>
              <FormInWrap>
                <label>Name</label>
                <FormInput
                  type='text'
                  id='workerName'
                  name='workerName'
                  readOnly={true}
                  value={item?.workerName || ''}
                />
              </FormInWrap>
            </FormIn>
            <FormIn>
              <FormInWrap>
                <label>Status</label>
                <select
                  name='attendanceState'
                  id='attendanceState'
                  value={item?.attendanceState || ''}
                  onChange={e => {
                    setItem(() => {
                      return {
                        ...item,
                        attendanceState: e.target.value,
                        lateReason: e.target.value === 'A' ? item.lateReason : '',
                        inTimeValue: e.target.value === 'A' ? '' : item.inTimeValue,
                        inTime: e.target.value === 'A' ? '' : item.inTime,
                      };
                    });
                  }}
                  disabled={moment().format('YYYY-MM-DD') !== props.props?.data.item.workDate}
                >
                  <option value={''}>-- Select --</option>
                  <option value={'Y'}>on Time</option>
                  <option value={'N'}>Late</option>
                  <option value={'A'}>Absence</option>
                </select>
              </FormInWrap>
              <FormInWrap>
                {item.attendanceState !== 'A' && !Common.isEmpty(item.attendanceState) &&
                  <>
                    <label>Go to work time</label>
                    <DatePicker
                      onChangeRaw={e => e.preventDefault()}
                      onChange={date => {
                        setItem(() => {
                          return {
                            ...item,
                            inTimeValue: date,
                            inTime: `${item.workDate} ${moment(date).format('HH:mm:ss')}`,
                          }
                        });
                      }}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={10}
                      timeCaption='Time'
                      dateFormat='HH:mm:ss'
                      selected={item?.inTimeValue}
                    />
                  </>
                }
              </FormInWrap>
            </FormIn>
            {item.attendanceState === 'A' &&
              <FormIn>
                <FormTextWrap>
                  <label>Reason</label>
                  <textarea
                    id='lateReason'
                    name='lateReason'
                    value={item?.lateReason || ''}
                    onChange={e => {
                      setItem(() => {
                        return {
                          ...item,
                          lateReason: e.target.value,
                        };
                      });
                    }}
                  />
                </FormTextWrap>
              </FormIn>
            }
            <FormBtn $Btn>
              <Btn onClick={closeModal}>Cancel</Btn>
              <Btn $Color onClick={setAttendance}>Check</Btn>
            </FormBtn>
          </ModalForm>
        </div>
      </div>
    </>
  );
}

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 700;
    font-size: 18px;
    color: #000000;
  }
`;

const ModalForm = styled.div`
  margin-top: 20px;
  position: relative;
  border-top: 1px solid #eeeeee;

  & > div + div {
    margin-top: 10px;
  }
`;

const FormIn = styled.div`
  display: flex;
  gap: 10px 20px;

  & select {
    width: calc(70% - 10px);
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
    border: 1px solid #cccccc;
    border-radius: 5px;
    outline: none;
    font-weight: 400;
    font-size: 16px;
    color: #000000;

    &:focus {
      border-color: #0072B9;
    }
  }

  & textarea {
    width: calc(85% - 7px);
    height: 150px;
    padding: 10px 16px;
    background: #f8f8f8;
    border-radius: 5px;
    border: 1px solid #cccccc;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    resize: none;
    outline: none;

    &:focus {
      border-color: #0072B9;
    }
  }
`;

const FormInWrap = styled.div`
  display: inline-flex;
  width: 50%;
  align-items: center;
  float: left;
  height: 60px;

  & label {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    width: 30%;
    margin-right: 10px;

    & span {
      font-size: 11px;
    }
  }

  .react-datepicker-wrapper {
    width: calc(70% - 10px);
    height: 40px;

    .react-datepicker__input-container {
      height: 100%;

      & input {
        width: 100%;
        height: 100%;
        line-height: 40px;
        padding: 0 16px;
        background: #f8f8f8;
        border: 1px solid #cccccc;
        border-radius: 5px;
        font-weight: 400;
        font-size: 16px;
        color: #000000;
        outline: none;
      }
    }
  }
`;

const FormTextWrap = styled.div`
  display: inline-flex;
  width: 100%;
  align-items: center;
  gap: 0 10px;
  float: left;
  height: 150px;

  & label {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    width: calc(15% - 3px);

    & span {
      font-size: 11px;
    }
  }
`;

const FormInput = styled.input`
  width: calc(70% - 10px);
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  background: #f8f8f8;
  border: 1px solid #cccccc;
  border-radius: 5px;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  outline: none;

  &:focus {
    border-color: #0072B9;
  }
`;

const FormBtn = styled.div`
  margin-top: 25px !important;
  display: flex;
  align-items: center;
  gap: 0 8px;
`;

const Btn = styled.button`
  flex: 1;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  text-align: center;

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

export default GoToWorkModal;